import { useState,useEffect } from "react";
import { useNavigate, generatePath, useParams } from "react-router-dom";
import http from "../../api/server";
import {
  DOOR_INSPECTION_API,
  // GET_PROPERTY_INFO_WITH_MASTER
  //GET_PROPERTY_USER_MAPPING,
  CONTRACT_INSPECTOR_ACCEPTANCE 
} from "../../api/apiPath";
import { useSelector } from "react-redux";
import Iframe from "react-iframe";
import { UserRoles, Statuses } from "../../components/common/constant";
import UploadPropertyImage from "./UploadPropertyImage";
import dayjs from "dayjs";
import Toaster from "./Toaster";

const PropertyTile = (props) => {
  const { clientNameParam } = useParams();
  const [showLoader, setShowLoader] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [showPropertyImageModal, setShowPropertyImageModal] = useState(false);
  const { userObj } = useSelector((state) => state.user);
  const [showNewSurveyIcon, setShowNewSurveyIcon] = useState(false);
  const [showAcceptIcon, setShowAcceptIcon] = useState(false);
  const [showAcceptPopup, setShowAcceptPopup] = useState(false);
  const [acceptFormData, setAcceptFormData] = useState({
    status: 'Select',
    comment: ""
  });
  const [validationFlag, setValidationFlag] = useState(false);
  const [showDownloadIcon, setShowDownloadIcon] = useState(false);
  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const {
    inspectionReferenceNumber,
    cityName,
    scheduledInspectionDate,
    blockName,
    propertyMasterId, 
    propertyName,
    propertyLocation,
    inspectedBy,
    //lastInspectionDate,
    // nextInspectionDueDate,
    status,
    // totalCompleted,
    totalAttention,
    propertyImage,
    inspectionAccepted,
    inspectionMasterId
  } = props.data;
    const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const navigate = useNavigate();
  const gotoDashBoard = (propertyId) => {
    const pathTemplate = "/client/:clientNameParam/dashboard/:propertyMasterId/:inspectionRefnumber";
    //const pathTemplate = "/client/:clientNameParam/scanNewDoor/:propertyMasterId/:inspectionRefnumber";
    const params = {
      clientNameParam: clientNameParam,
      propertyMasterId: propertyId,
      inspectionRefnumber: inspectionReferenceNumber
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };

 useEffect(() => {
    getPropertyUserMapping();
  }, [props?.data]);
  // const handleDownloadClick = async () => {
  //   console.log("try download");
  //   setShowLoader(true);

  //   try {
  //     const response = await http.get(DOOR_INSPECTION_API, {
  //       responseType: "blob", // VERY IMPORTANT
  //     });

  //     // Create a link element
  //     const url = window.URL.createObjectURL(new Blob([response.data]));
  //     const link = document.createElement("a");setInspectorInspectionStatus
  //     link.href = url;

  //     // Optional: set a filename
  //     link.setAttribute(
  //       "download",
  //       "Heaton Newcastle_DoorInspectionReport.pdf"
  //     );

  //     // Append to DOM and trigger click
  //     document.body.appendChild(link);
  //     link.click();

  //     // Clean up
  //     link.remove();
  //     window.URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.error("Download Failed", error);
  //   } finally {
  //     setShowLoader(false);
  //   }
  // };
    const getPropertyUserMapping = async () => {
      // const propInfoResp = await http.get(
      //   GET_PROPERTY_USER_MAPPING + propertyMasterId
      // );
      // if (!propInfoResp.status) {
      //   throw new Error(`HTTP error! status: ${propInfoResp?.status}`);
      // }
      // var inspectorInspectionStatus = propInfoResp?.data?.filter(d => d.userId == userObj.userId)[0]?.status;
      
      // if ((((status !== Statuses.COMPLETED && status !== Statuses.REJECTED && status !== Statuses.SUBMITTEDFORAPPROVAL) 
      //   && (inspectorInspectionStatus !== Statuses.COMPLETED))
      //   || (new Date(nextInspectionDueDate) <= new Date() && new Date(nextInspectionDueDate).getFullYear() > new Date().getFullYear()-1)) && props?.userRole === UserRoles.INSPECTOR) {
      //   setShowNewSurveyIcon(true);
      // } else {
      //   setShowNewSurveyIcon(false);
      // }
      // const response1 = await http.get(
      //   GET_PROPERTY_INFO_WITH_MASTER + propertyMasterId + "?InspectionReferenceNumber=" + inspectionReferenceNumber
      // );
      // if (!response1.status) {
      //   throw new Error(`HTTP error! status: ${response1?.status}`);
      // }
      // const inspection_status = 
      const scheDate = new Date(scheduledInspectionDate);
      const todayDate = new Date();

      // Normalize to date-only strings
      const d1 = dayjs(scheDate).format("YYYY-MM-DD");
      const d2 = dayjs(todayDate).format("YYYY-MM-DD");

      // Compare as strings
      const isBeforeOrSame = d1 <= d2;
      console.log(isBeforeOrSame);

      if(props?.userRole === UserRoles.INSPECTOR &&
        (status === Statuses.SCHEDULED || status === Statuses.INPROGRESS) && 
        isBeforeOrSame && 
        (new Date(scheduledInspectionDate).getFullYear() > new Date().getFullYear()-1)
      ){
        setShowNewSurveyIcon(true);
      }else{
        setShowNewSurveyIcon(false)
      }

      if(props?.userRole === UserRoles.INSPECTOR && status === Statuses.PENDINGINSPECTORAPPROVAL && inspectionAccepted === null){
        setShowAcceptIcon(false); //set to false for prod
      }else{
        setShowAcceptIcon(false);
      }
      console.log("status",showAcceptIcon);
       
      if(status !== Statuses.NOTSTARTED && status !== Statuses.INREVIEW && status !==null && status !== undefined) {
        setShowDownloadIcon(true)
      }
    
    };

  const handleDownloadClick = async (propertyId) => {
      setShowLoader(true);
      try {
        const response = await http.get(DOOR_INSPECTION_API, {
          params: {
            propertyId: propertyId,
          },
          responseType: "blob",
        });
  
        const file = new Blob([response.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
  
        setPdfUrl(fileURL);
        if(isMobile) {
          const link = document.createElement("a");
          link.href = fileURL;
          link.download = `${propertyId}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }else{
          setShowPdfModal(true); // 👉 show modal
        }
       
      } catch (error) {
        console.error("Download Failed", error);
      } finally {
        setShowLoader(false);
      }
    };

  const handleDate = (datetime) => {
    if (datetime !== null && datetime !== undefined) {
      const date = new Date(datetime);
      const shortDate = date.toLocaleDateString("en-US");
      return shortDate;
    }
  };

  const gotoPropertyView = (propertyId) => {
    const pathTemplate = "/client/:clientNameParam/property-view-details/:propertyMasterId/:inspectionRefnumber";
    const params = {
      clientNameParam: clientNameParam,
      propertyMasterId: propertyId,
      inspectionRefnumber: inspectionReferenceNumber
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath,  { state: { propertyInfo: props?.data,userRole:props?.userRole }});
  };

  const checkPropertyImage = (propertyImage) => {
    propertyImage?.trim() === "" ? setShowPropertyImageModal(true) : gotoDashBoard(propertyMasterId);
  }

   const handleCancel = () => {
    setShowPropertyImageModal(false);
  };

  const handleCancelAccept = () => {
    setShowAcceptPopup(false);
  }

  const handleFormDataChange = (e) => {
    setAcceptFormData({ ...acceptFormData, comment: e.target.value });
  };
  const handleStatusChange = (e) => {
    setAcceptFormData({
      ...acceptFormData,
      status: e.target.value
    });
  }

  const handleAcceptValidation = async () => {
    let isValid = true;
    // Basic validation
    if (!acceptFormData.status || acceptFormData.status === "Select") {
      isValid = false;
    }
    if ( acceptFormData.status === "Rejected" && (!acceptFormData.comment || acceptFormData.comment.trim() === "")) {
      isValid = false;
    }
    setValidationFlag(!isValid);
    if(isValid){
      setShowLoader(true);
      const payload = {
        inspectorUserId: userObj?.userId,
        inspectionMasterId: inspectionMasterId,
        isAccepted: acceptFormData.status === "Accepted" ? true : false,
        rejectReason: acceptFormData.comment
      };
      try{
        const response = await http.post(CONTRACT_INSPECTOR_ACCEPTANCE, payload);
        console.log("Acceptance Response:", response, response.isSuccess);
       
        if(response.status === 200){
          setShowLoader(false);
          setShowAcceptPopup(false);
          props.refreshPage();
          setTimeout(() => {
            props.refreshPage();
          }, 100);
          const message = acceptFormData.status === "Accepted" ? "Inspection accepted successfully." : "Inspection rejected successfully.";
          setTimeout(() => {
            setToastData({
            toastShow: true,
            toastType: "success",
            toastString: message,
          })
          }, 2000);
        }else{
          setShowLoader(false);
          setShowAcceptPopup(false);
          
          setTimeout(() => {
            setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in submitting acceptance. Please try again.",
          })
          }, 2000);
        }

      }catch(err){
        console.error("Error in submitting acceptance:", err);
        setShowLoader(false);
          setShowAcceptPopup(false);
        setTimeout(() => {
            setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in submitting acceptance. Please try again.",
          })
          }, 2000);
      }
      

    }
  }

    const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  return (
    <div className="row m-0">
      <div className="col-12 col-sm-12 mb-3">
        <div className="card bulid_card">
          <div className="card-body bulid_card_main d-flex align-items-center flex-wrap row-gap-3" style={{justifyContent:"space-between"}}>
            <div className="col-12 col-sm-12 col-lg-5 d-flex align-items-center gap-2">
              <i className="bi bi-building fs-1"></i>
              <div className="bulid_card_info">
                {/* <p
                  className="mb-1 fw-semibold"
                  style={{ textAlign: "justify" }}
                >
                  {blockName}
                </p> */}
                <p
                  className="mb-1 fw-semibold"
                  style={{ textAlign: "justify" }}
                >
                  {propertyName}
                </p>
                <div
                  className="bulid_sub_info_main d-flex flex-wrap"
                  style={{ flexDirection: "column" }}
                >
                  <div className="bulid_sub_info d-flex align-items-center gap-1">
                    <i className="fa-solid fa-map-location"></i>
                    <small>{inspectionReferenceNumber}</small>
                  </div>
                  <div className="bulid_sub_info d-flex align-items-center gap-1">
                    <i className="fa-solid fa-map-location"></i>
                    <small>{blockName}{", "}{propertyLocation}</small>
                  </div>
                  <div className="bulid_sub_info d-flex align-items-center gap-1">
                    <i className="bi bi-geo-alt"></i>
                    <small>{cityName}</small>
                  </div>
                  <div className="bulid_sub_info d-flex align-items-center gap-1">
                    <i className="bi bi-person-circle"></i>
                    <small>{inspectedBy}</small>
                  </div>
                  <div className="bulid_sub_info d-flex align-items-center gap-1">
                    <i className="bi bi-calendar3"></i>
                    <small>{handleDate(scheduledInspectionDate)}</small>
                  </div>
                  <div className="bulid_sub_info d-flex align-items-center gap-1">
                    <i className="bi bi-person-circle"></i>
                    <small>{status}</small>
                  </div>
                </div>
              </div>
            </div>
            {status === "In Review" || status === "In Progress" && (
              <div className="col-12 col-sm-8 col-lg-4 col-lg-4-padding col-sm-8-padding inprogress">
                <div className="d-flex mb-2 align-items-center justify-content-between ">
                  {/* <span>{totalCompleted} completed</span> */}
                  <button type="button" className="btn btn-warning">
                    {" "}
                    <span className="icon-circle">
                      <i className="bi bi-circle-fill"></i>{" "}
                      <span className="ms-1">In progress</span>{" "}
                    </span>
                  </button>
                </div>
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    aria-label="Basic example"
                    style={{ width: "50%" }}
                    aria-valuenow="50"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            )}
            {status === "Completed" && (
              <div className="col-12 col-sm-8 col-lg-4 col-lg-4-padding col-sm-8-padding completed">
                <div className="d-flex mb-2 align-items-center justify-content-between ">
                  {/* <span>{totalCompleted} completed</span> */}
                  <button type="button" className="btn btn-warning">
                    <span className="icon-circle">
                      <i className="bi bi-check-circle"></i>{" "}
                      <span className="ms-1">Completed</span>
                    </span>
                  </button>
                </div>
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    aria-label="Basic example"
                    style={{ width: "100%" }}
                    aria-valuenow="100"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            )}
            {status === "Scheduled" && (
              <div className="col-12 col-sm-8 col-lg-4 col-lg-4-padding col-sm-8-padding started">
                <div className="d-flex mb-2 align-items-center justify-content-between ">
                  {/* <span>{totalCompleted} completed</span> */}
                  <button type="button" className="btn btn-warning">
                    <span className="icon-circle" />
                    <i className="bi bi-play-circle-fill"></i>
                    <span className="ms-1">Scheduled</span>{" "}
                  </button>
                </div>
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    aria-label="Basic example"
                    style={{ width: "0%" }}
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            )}
            {status === "Rejected" && (
              <div className="col-12 col-sm-8 col-lg-4 col-lg-4-padding col-sm-8-padding rejected">
                <div className="d-flex mb-2 align-items-center justify-content-between ">
                  {/* <span>{totalCompleted} completed</span> */}
                  <button type="button" className="btn">
                    <span className="icon-cross" />
                    <i className="bi bi-x-circle text-danger"></i>
                    <span className="ms-1">Rejected</span>{" "}
                  </button>
                </div>
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    aria-label="Basic example"
                    style={{ width: "0%" }}
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            )}
            {status === "Submitted for Approval" && (
              <div className="col-12 col-sm-8 col-lg-4 col-lg-4-padding col-sm-8-padding started">
                <div className="d-flex mb-2 align-items-center justify-content-between ">
                  {/* <span>{totalCompleted} completed</span> */}
                  <button type="button" className="btn">
                    <span className="icon-circle" />
                    <i className="bi bi-play-circle-fill"></i>
                    <span className="ms-1">Submitted for Approval</span>{" "}
                  </button>
                </div>
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    aria-label="Basic example"
                    style={{ width: "75%" }}
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            )}
            <div className="col-12 col-sm-4 col-lg-3">
              <div className="d-flex gap-2 justify-content-between  align-items-center">
                <div className="d-flex gap-2">
                  <i className="bi bi-exclamation-triangle text-danger"></i>
                  <span>{totalAttention} Critical Issue(s) Found</span>
                </div>
                <div className="d-flex gap-3" style={{ alignItems: "center" }}>
                  {showAcceptIcon &&
                    <i
                      className="bi fa-solid fa-file-pen fa-lg"
                      title="Accept/Reject Inspection"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setShowAcceptPopup(true);
                      }}
                    ></i>
                  }
                  <i
                    className="fa-solid fa-eye fa-lg"
                    title="View Survey"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      gotoPropertyView(propertyMasterId);
                    }}
                  ></i>
                  {showNewSurveyIcon &&
                    <i
                      className="bi fa-solid fa-plus fa-lg"
                      title="New Survey"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        checkPropertyImage(propertyImage);
                      }}
                    ></i>
                  }
                  {showLoader ? (
                    <div className="loader"></div>
                  ) : (
                    showDownloadIcon &&
                    <i
                      className="bi fa-solid fa-download fa-lg"
                      title="Download PDF"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        handleDownloadClick(propertyMasterId);
                      }}
                    ></i>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showPdfModal && pdfUrl && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 1050,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "90%",
              maxHeight: "80vh",
              backgroundColor: "#fff",
              borderRadius: "8px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                padding: "10px 15px",
                borderBottom: "1px solid #ddd",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5 className="modal-title mb-0">PDF Preview</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  setShowPdfModal(false);
                  setPdfUrl(null);
                }}
              ></button>
            </div>
            <div style={{ height: "90vh", padding: 0 }}>
       
              <Iframe
                src={pdfUrl}
                width="100%"
                height="100%"
                title="PDF Preview"
                style={{
                  border: "none",
                  display: "block",
                  width: "100%",
                  height: "100%",
                }}
                frameBorder="0"
              ></Iframe>
            </div>
          </div>
        </div>
      )}
      {showPropertyImageModal && <UploadPropertyImage 
      propertyId={propertyMasterId} 
      handleCancel={handleCancel}
      propertyName={propertyName}
      inspectionRefnumber={inspectionReferenceNumber}
      />}
      {showAcceptPopup && (
        <div className="modal-overlay">
              <div className="approval-modal-content" style={{height:"fit-content"}}>
                <span className="close" onClick={handleCancelAccept}>
                  &times;
                </span>
                <h6 className="modal-header">
                  Pending Inspector Acceptance
                </h6>{" "}
                {/* Modal Header */}
                <div className="modal-body">
                  <div>
                    <p>Please Accept the scheduled inspection for property : {propertyName}</p>
                    
                    <div className="row">
                      <div className="col-sm-6 col-md-6 mb-3">
                        <div className="form-floating">
                          <select
                            className="form-select"
                            id="floatingSelect"
                            
                            aria-label="Floating label select example"
                            value={acceptFormData.status}
                            onChange={handleStatusChange}
                          >
                            <option selected>Select</option>
                            <option value="Accepted">Accept</option>
                            <option value="Rejected">Reject</option>
                          </select>
                          <label htmlFor="floatingSelect">Status </label>
                        </div>
                      </div>
                        
                    </div>
                    <div className="form-floating">
                      <textarea
                        className="form-control"
                        rows="5"
                        style={{ minHeight: "auto", height: "auto" }}
                        placeholder="Comments"
                        value={acceptFormData.comment}
                        id="floatingTextarea"
                        name="comment"
                        onChange={(e) => handleFormDataChange(e)}
                      ></textarea>
                      <label htmlFor="floatingTextarea">Comments {acceptFormData.status == "Rejected" ? <span style={{ color: 'red' }}>*</span> : ""}</label>
                    </div>
                  </div>
                  <div className="row mt-3" style={{marginRight:"0px"}}>
                    {showLoader ? (
                      <div className="approvalLoader" style={{ marginLeft: '45%' }}></div>
                    ) : (
                      <div>
                      <div> {validationFlag && <small style={{ color: 'red',float:'left' }} className=" mb-1">* Please fill all required fields</small>}</div>
                      <div className="card-body action_btns d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap">
                        
                        <button type="button" className="btn btn-tertiary" onClick={() => { handleCancelAccept() }}>
                          Cancel
                        </button>
                        <button type="button" className="btn btn-primary"  onClick={() => handleAcceptValidation()}>
                          Submit
                        </button>
                      </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
      )}

      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={() => {
          closeButton();
        }}
      />
    </div>
  );
};

export default PropertyTile;
